import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api/apiSlice';
import authReducer from '../features/Auth/authSlice';
import searchReducer from '../features/Search/searchSlice';
import profileReducer from '../features/Profile/profileSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import giftReducer from '../features/Gift/giftSlice';
import userReducer from '../features/Users/userSlice';
import chatReducer from '../features/Chats/chatSlice';
import gnnReducer from '../features/Gnn/gnnSlice';
import announcementReducer from '../features/Announcement/announcementSlice';
import resumeReducer from '../features/Resume/resumeSlice';
import webviewReducer from '../features/WebView/webviewSlice'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'search'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  search: searchReducer,
  profile: profileReducer,
  gift: giftReducer,
  user: userReducer,
  chat: chatReducer,
  gnn: gnnReducer,
  announcement: announcementReducer,
  resume: resumeReducer,
  webview: webviewReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(apiSlice.middleware),
  devTools: true,
});

export const persistor = persistStore(store);
